import { Component } from '@angular/core';
import { Asset, MontageBuilderService, ViewMode } from '../..';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthorizeControlService } from 'pr1-ui-components';
import { PageEvent } from '@angular/material/paginator';
import { SelectionModel } from '@angular/cdk/collections';
import { combineLatest, distinctUntilChanged, map, Subscription } from 'rxjs';
import { PreviewMode, UtilityService } from 'src/app/@shared';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { FormControl, FormGroup } from '@angular/forms';
import { Sort } from '@angular/material/sort';
const DEFAULT_SEARCH_PLACEHOLDER = 'Search Assets';

@Component({
  selector: 'app-montage-assets-list',
  templateUrl: './montage-assets-list.component.html',
  styleUrls: ['./montage-assets-list.component.scss']
})
export class MontageAssetsListComponent {
  context = 'Offers'; //Products, Events, Offers, Promos, OfferGroups, Brands, Versions, Coupons
  contextId = '';
  PreviewMode = PreviewMode;
  ViewMode = ViewMode;
  defaultViewMode = ViewMode.Card;
  searchPlaceholder: string = DEFAULT_SEARCH_PLACEHOLDER;
  searchQuery: string = '';

  showFirstLastButtons = true;
  pageEvent: PageEvent = new PageEvent;
  pageSizeOptions = [5, 10, 20, 50, 100, 500];

  allIdsByContext: string[] = [];

  selection = new SelectionModel<Asset>(true, [], true, (a1, a2) => a1.Detail.Id === a2.Detail.Id);
  displayedColumns = ['select', 'Image', 'AssetName', 'Type', 'Group', 'DateAdded', 'DateCreated'];
  flexMediaWatcher!: Subscription;
  assets: Asset[] = [];
  viewModel$ = combineLatest([
    this.montageBuilderService.assetsList$,
    this.montageBuilderService.isLoading$,
    this.montageBuilderService.totalRecords$,
    this.montageBuilderService.page$
  ]).pipe(
    map(([assets, isLoading, totalRecords, page]) => {
      if (assets.length == 0 && page.pageIndex > 0) {
        page.previousPageIndex = 0
        page.pageIndex = 0
        this.montageBuilderService.page(page);
        this.montageBuilderService.reload();
      }

      this.assets = assets;
      return { assets, isLoading, totalRecords, page }
    }),
  );
  filtersForm = new FormGroup({
    search: new FormControl<string | null>(null),
  });
  constructor(
    private mediaObserver: MediaObserver,
    private authorizationService: AuthorizeControlService,
    public utilityService: UtilityService,
    private montageBuilderService: MontageBuilderService,
    private dialogRef: MatDialogRef<MontageAssetsListComponent>,
  ) { }

  ngOnInit() {
    this.detectViewportSizeChange();
  }

  ngOnDestroy(): void {
    this.montageBuilderService.resetServiceState();
  }

  canEdit(): boolean {
    return this.authorizationService.checkAccess('edit||offermang');
  }

  detectViewportSizeChange() {
    // detect changes in viewport size to handle show/hide of table columns
    const getAlias = (MediaChange: MediaChange[]) => {
      return MediaChange[0].mqAlias;
    };

    this.flexMediaWatcher = this.mediaObserver
      .asObservable()
      .pipe(
        distinctUntilChanged(
          (x: MediaChange[], y: MediaChange[]) => getAlias(x) === getAlias(y)
        ))
      .subscribe((change) => {
        if (change.some(x => x.mqAlias === 'xs')) {
          this.displayedColumns = ['select', 'Image', 'AssetName'];
        } else if (change.some(x => x.mqAlias === 'sm')) {
          this.displayedColumns = ['select', 'Image', 'AssetName', 'Type', 'Group', 'DateAdded', 'DateCreated'];
        } else {
          this.displayedColumns = ['select', 'Image', 'AssetName', 'Type', 'Group', 'DateAdded', 'DateCreated'];
        }
      });
  }

  toggleView(mode: ViewMode) {
    this.defaultViewMode = mode;
  }
  cancelPop() {
    this.dialogRef.close([]);
    this.selection.clear();
  }
  selectAssets() {
    let selectedAssets: any[] = [];
    this.assets.forEach(item => {
      if (this.selection.isSelected(item)) {
        selectedAssets.push(item)
      }
    });
    this.dialogRef.close(selectedAssets);
  }

  clearSearch(): void {
    this.searchQuery = '';
    this.onSearch();
  }

  onSearch() {
    this.selection.clear();
    this.montageBuilderService.search(this.searchQuery);
  }

  onSort(sortState: Sort): void {
    this.montageBuilderService.sort(sortState);
    this.selection.clear();
  }

  onPageChange(pageEvent: PageEvent): void {
    this.selection.clear();
    this.montageBuilderService.page(pageEvent);
  }

  toggleSelect(checked: boolean, asset: any) {
    if (checked) {
      if (!this.selection.isSelected(asset)) {
        this.selection.select(asset);
      }
    } else {
      this.selection.deselect(asset);
    }
  }

  toggleSelectAll(checked: boolean): void {
    if (checked) {
      this.assets.forEach(item => {
        if (!this.selection.isSelected(item)) {
          this.selection.select(item);
        }
      });
    } else {
      this.assets.forEach(item => {
        this.selection.deselect(item);
      });
    }
  }

  isAllSelectedOnPage(): boolean {
    return this.assets.every(item => this.selection.isSelected(item));
  }

  isSomeSelectedOnPage(): boolean {
    return this.assets.some(item => this.selection.isSelected(item));
  }

}
